/**
 * MKS-508 — company docs queries.
 *
 * A 404 is an answer (an unknown slug), not a transient failure, so it is not
 * retried.
 */
import { useQuery } from '@tanstack/react-query';
import { getCompanyDoc, listCompanyDocs } from '../services/api/docs';
import { ApiClientError } from '../services/api/client';

const STALE_TIME_MS = 5 * 60 * 1000;

function retryUnlessNotFound(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiClientError && error.statusCode === 404) return false;
  return failureCount < 3;
}

export function useCompanyDocs() {
  return useQuery({
    queryKey: ['company-docs'],
    queryFn: listCompanyDocs,
    staleTime: STALE_TIME_MS,
    retry: retryUnlessNotFound,
  });
}

export function useCompanyDoc(slug: string | undefined) {
  return useQuery({
    queryKey: ['company-docs', slug],
    queryFn: () => getCompanyDoc(slug as string),
    enabled: Boolean(slug),
    staleTime: STALE_TIME_MS,
    retry: retryUnlessNotFound,
  });
}
